import {
  AvailabilityBlockSource,
  BookingIssue,
  BookingPaymentBalanceStatus,
  DateRange,
  HomeLinks,
  IDate,
  LeadSource,
  ZonedDateTime,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

enum PeriodKind {
  booking = 'booking',
  block = 'block',
  backToBack = 'backToBack',
}

enum TapeChartType {
  booking = 'booking',
  pricing = 'pricing',
  seasonPricing = 'seasonPricing',
  revenue = 'revenue',
  discounts = 'discounts',
}

export interface PeriodSharedProps {
  id: string
  kind: PeriodKind
  homeId: string
  startDate: string
  endDate: string
  expiresAt?: ZonedDateTime
}

interface BookingInfo {
  hash: string
  detailedCheckIn: {
    effectiveTime: IDate
  }
  detailedCheckOut: {
    effectiveTime: IDate
  }
  guestName: string
  home: {
    name: string
  }
}

export interface AvailabilityBlockView {
  note?: string
  createdAt?: string | IDate
  updatedAt?: string | IDate
  createdBy?: string
  updatedBy?: string
  expiresAt?: ZonedDateTime
  notificationSetting?: {
    notifyAuthor: boolean
    notifyRelocationTeam: boolean
    notifyFieldOpsTeam: boolean
  }
  booking?: BookingInfo
}

export interface ParentAvailabilityBlockView extends AvailabilityBlockView {
  id: string
  homeId: string
  period: DateRange
  source: AvailabilityBlockSource
  bookingId?: string
}

export interface BlockViewProps extends AvailabilityBlockView {
  reason?: string
  parent?: ParentAvailabilityBlockView
}
export interface BlockPeriod extends PeriodSharedProps, BlockViewProps {}

interface Period extends BlockViewProps, PeriodSharedProps {
  // when early check-in or late check-out is confirmed
  eci?: IDate
  lco?: IDate

  issues?: BookingIssue[]
  flags?: string[]
  // when kind = PeriodKind.booking
  guestName?: string
  source?: LeadSource
  hash?: string
  securityDepositStatus?: boolean | null
  home?: {
    links?: HomeLinks
  }
  paymentBalanceStatus?: BookingPaymentBalanceStatus
  activeServicesCount: number
  folio?: BookingFolioView
}

export interface BookingFolioView {
  summary: Partial<BookingFolioSummary>
}

export interface BookingFolioSummary {
  total: number
}

export interface TapeChartRegionHeaderData {
  regionData: {
    [key: string]: {
      regionName: string
      propertyCount: number
    }
  }
  firstProperties: {
    [key: string]: boolean
  }
}

export { Period, PeriodKind, TapeChartType }
